<nb-card class="modalSize">
  <!-- <nb-card-header>{{ title }}</nb-card-header> -->
  <nb-card-body>
    <img [src]="image" id="viewableImage" style="max-width: -webkit-fill-available;"/>
    <div style="display: flex; justify-content: center;margin-top: 20px;">

      <!-- <button class=" imgControlBtn" (click)="rotate()"><i class="fa fa-repeat" aria-hidden="true"></i></button> -->
    </div>
  </nb-card-body>

  <nb-card-footer [ngStyle]="{'text-align': apiService.currentDirection == 'rtl'? 'left': 'right'}">
    <div style="width: 100%;text-align: center;">
          <button class=" imgControlBtn" (click)="zoomIn(1)"><i class="fa fa-search-plus" aria-hidden="true"></i></button>
    <button class=" imgControlBtn" (click)="zoomIn(-1)"><i class="fa fa-search-minus" aria-hidden="true"></i></button>
    </div>

    <button nbButton status="primary" (click)="close()">{{'Close'|translate}}</button>
  </nb-card-footer>
</nb-card>